import React from 'react';
import { Spin, Row } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const Loading = () => {
    const LoadingIcon = <LoadingOutlined sytle={{ fontSize: 30 }} />;
    return (
        <Row justify="center">
            <Spin indicator={LoadingIcon} size="large" />
        </Row>
    );
};

export default Loading;
